import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/746b1d40/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`File uploader`}</h2>
    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/fileuploader--fileuploader",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-file-uploader--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvfileuploader--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=file-uploader"
    }} knobs={{
      FileUploader: ["multiple"]
    }} mdxType="ComponentDemo">
  {`
<div className="bx--file__container">
  <FileUploader
    accept={[
      '.jpg',
      '.png'
    ]}
    buttonKind="primary"
    buttonLabel="Add files"
    filenameStatus="edit"
    iconDescription="Clear file"
    labelDescription="only .jpg files at 500mb or less"
    labelTitle="Upload"
  />
</div>
  `}
    </ComponentDemo>
    <h2>{`Drag and drop`}</h2>
    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/fileuploader--drag-and-drop-upload-container-example-application",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-file-uploader--drag-and-drop",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvfileuploader--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=file-uploader"
    }} knobs={{
      FileUploaderDropContainer: ["multiple", "disabled"]
    }} mdxType="ComponentDemo">
  {`
  <div className="bx--file__container">
    <strong className='bx--file--label'>Account photo</strong>
    <p className='bx--label-description'>
      Only .jpg and .png files. 500kb max file size
    </p>
    <FileUploaderDropContainer
      accept={[
        'image/jpeg',
        'image/png'
      ]}
      labelText="Drag and drop files here or click to upload"
      tabIndex={0}
    />
  </div>
  `}
    </ComponentDemo>
    <h2>{`Upload states`}</h2>
    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/fileuploader--fileuploaderitem",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-file-uploader--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvfileuploader--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=file-uploader"
    }} knobs={{
      FileUploaderItem: ["status", "invalid"]
    }} mdxType="ComponentDemo">
  {`
  <div className="bx--file__container">
    <FileUploaderItem name='color.jpg' errorSubject='File size exceeds limits' errorBody='500 kb max file size. Select a new file and try again.'/>
  </div>
  `}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      